import type { AxiosRequestConfig } from 'axios';
import api from '../../api/axios';
import { normalizeAdminApiError } from './errors';
import type { ApiResponse, MutationSafetyOptions } from './types';

function idempotencyKey(): string {
    return typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `admin-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function configForMutation(options?: MutationSafetyOptions): AxiosRequestConfig {
    return options?.idempotencyKey
        ? { headers: { 'Idempotency-Key': options.idempotencyKey } }
        : {};
}

export function createIdempotencyKey(): string {
    return idempotencyKey();
}

export async function adminGet<T>(path: string, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
    try {
        return (await api.get<ApiResponse<T>>(path, config)).data;
    } catch (error) {
        throw normalizeAdminApiError(error);
    }
}

export async function adminMutation<T>(
    method: 'post' | 'patch' | 'put' | 'delete',
    path: string,
    body?: unknown,
    safety?: MutationSafetyOptions,
): Promise<ApiResponse<T>> {
    try {
        const payload = body && typeof body === 'object'
            ? { ...body, ...(safety?.reason ? { reason: safety.reason } : {}), ...(safety?.confirmation ? { confirmation: safety.confirmation } : {}) }
            : body;
        return (await api.request<ApiResponse<T>>({ method, url: path, data: payload, ...configForMutation(safety) })).data;
    } catch (error) {
        throw normalizeAdminApiError(error);
    }
}
